import React, { useEffect, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { Form, Input, Button, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

// App imports
import { AuthWrapper } from './style';
import { login } from '../../../../redux/authentication/actionCreator';
import Heading from '../../../../components/heading/heading';

const SignIn = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const [form] = Form.useForm();

  const handleSubmit = async values => {
    const response = await dispatch(login(values));
    if (response) {
      history.replace('/admin');
      setTimeout(() => {
        document.location.reload();
      }, 200);
    }
  };

  return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form name="login" form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item name="usuario" rules={[{ message: '¡Escríbe tu usuario!', required: true }]} label="Usuario">
            <Input />
          </Form.Item>
          <Form.Item
            name="contrasena"
            rules={[{ message: '¡Escríbe tu contraseña!', required: true }]}
            label="Contraseña"
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button className="btn-signin" htmlType="submit" type="primary" size="large" disabled={isLoading}>
              {isLoading ? 'Cargando...' : 'Ingresar'}
            </Button>
          </Form.Item>
        </Form>
      </div>
      <p className="text-center">
        <small>Si necesitas ayuda para ingresar, por favor comunícate a Gerencia General</small>
        </p>
      <div className="text-center">
        <Spin spinning={!!isLoading} />
      </div>
    </AuthWrapper>
  );
};

export default SignIn;
